// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../css-loader/index.js??ref--5-1!./image.css");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../vue-style-loader/lib/addStylesClient.js")("753f5e9f", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/image.css
// module id = 588
// module chunks = 8